export const comingSoonPages = ['notifications', 'search', 'requests'];
